import { render } from "./MapAssociations.vue?vue&type=template&id=5809d084&scoped=true"
import script from "./MapAssociations.vue?vue&type=script&lang=js"
export * from "./MapAssociations.vue?vue&type=script&lang=js"

import "./MapAssociations.vue?vue&type=style&index=0&id=5809d084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5809d084"]])

export default __exports__